import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        language: new String(),
        renderer: null,
        aplicacion: null,
    },
    getters: {
        getLanguage(state) {
            return state.language;
        },
        getRenderer(state) {
            return state.renderer;
        },
        obtenerDimensiones: (state) => (seleccion, aplicacion) => {
            const { lavabo, mueble } = seleccion;

            const dimxLavabo = lavabo.dimx;
            const dimzLavabo = lavabo.dimz;
            const dimyLavabo = lavabo.dimy;
            const dimxMueble = mueble.dimx;
            const dimzMueble = mueble.dimz;
            const dimyMueble = mueble.dimy;
            const modelo = mueble.modelo;



            const lavModeloCod = aplicacion?.getProducto()?.getModelo()?.cod;


            // obtenemos la referencia del lavabo
            const referenciaModelo = seleccion.referencias?.modelo;

            // calculamos el margen a restar según modelo o referencia especial
            // Verificamos si es frame o tiene extra_frame activado
            const isFrameOrExtraFrame = modelo === 'frame' || mueble.mueble_extra_frame;
            
            const margenLavabo =
                isFrameOrExtraFrame ? 0.039 + 0.002 : modelo === 'cabinet' ? 0.075 : 0;

            const anchoLavabo = dimxLavabo - margenLavabo;

            let ajuste = 0;
            if (isFrameOrExtraFrame) ajuste = 20.5;
            else if (modelo === 'cabinet') ajuste = 37.5;
            else if (
                (modelo === 'line' || modelo === 'drawer') &&
                lavModeloCod === 'W.37'
            )
                ajuste = -50;

            // Ajuste para W.37 con line o drawer: restar 50mm (0.05m)
            let ajusteW37Profundidad = 0;
            if ((modelo === 'line' || modelo === 'drawer') && lavModeloCod === 'W.37') {
                ajusteW37Profundidad = 50; // en mm
            }

            const profundoMueble = dimzLavabo * 1000 - ajusteW37Profundidad;

            let alturaMueble = 0;

            // Cálculo de altura considerando extra_frame
            if (isFrameOrExtraFrame) {
                // Para frame/extra_frame:
                // - Si lavabo <= 270mm → mueble = 240mm (fijo)
                // - Si lavabo > 270mm → mueble = lavabo - 30mm
                if (dimyLavabo <= 0.27) {
                    alturaMueble = 0.24;
                } else {
                    alturaMueble = dimyLavabo - 0.03;
                }
            } else {
                switch (modelo) {
                    case 'cabinet':
                        alturaMueble = 0.84;
                        break;
                    case 'drawer':
                        alturaMueble = 0.39;
                        break;
                    case 'line':
                        alturaMueble = 0.243;
                        break;
                    case 'unit':
                        alturaMueble = 0.66;
                        break;
                    default:
                        break;
                }
            }

            let profundoLavabo = 0;
            let grosorMueble = 0;

            // Calcular grosor del mueble según el modelo
            // Calcular grosor del mueble considerando extra_frame
            if (isFrameOrExtraFrame) {
                grosorMueble = 0.0205;
            } else if (modelo === 'cabinet') {
                grosorMueble = 0.0375;
            } else {
                grosorMueble = 0;
            }

            if (isFrameOrExtraFrame) {
                profundoLavabo = profundoMueble / 1000 - 0.021;
            } else if (modelo === 'cabinet') {
                profundoLavabo = profundoMueble / 1000 - 0.039;
            } else {
                profundoLavabo = dimzLavabo;
            }

            // if (lavModeloCod === 'W.37') {
            //   profundoLavabo = dimzLavabo - 0.05;
            //   console.log('Es modelo W.37');
            // } else {
            //   console.log('No es modelo W.37');
            // }
            const alturaLavabo = dimyLavabo;

            const anchoMueble = dimxLavabo;

            let profundidadCubeta = 0;

            // Calcular ancho de cubeta según el modelo de lavabo
            switch (lavModeloCod) {
                case 'W.37':
                    profundidadCubeta = dimzLavabo - 0.1 ;
                    // Para W.37, el ancho de la cubeta 
                    break;
                case 'L.28':
                    // Para L.28, el ancho de la cubeta es el ancho menos el grosor del mueble y un margen
                    // El grosorMueble ya está calculado correctamente para frame y extra_frame
                    profundidadCubeta = dimzLavabo - 0.05 - grosorMueble;
                    // Ajuste si tiene taladros montados en encimera
                    if (
                        seleccion.cubetas &&
                        seleccion.cubetas.cubeta1_tala &&
                        seleccion.cubetas.cubeta1_tala_mon === 'encimera'
                    ) {
                        profundidadCubeta = dimzLavabo - 0.1 - grosorMueble;
                    }
                    break;
                case 'G.19':
                    if (modelo === 'cabinet') {
                        profundidadCubeta = profundoLavabo - 0.05; // 50mm
                    } else if (isFrameOrExtraFrame) { // Usar isFrameOrExtraFrame para incluir tanto frame como extra_frame
                        profundidadCubeta = profundoLavabo - 0.05;
                    } else {
                        profundidadCubeta = dimzLavabo - 2 * 0.025;
                    }
                    break;
                case 'A.71':
                    // Para A.71, usar profundoLavabo que ya tiene en cuenta si es frame o extra_frame
                    profundidadCubeta = profundoLavabo - 2 * 0.025;
                    break;
                default:
                    // Por defecto, usar profundoLavabo que ya considera frame y extra_frame,
                    // y restar los bordes de 25mm
                    if (isFrameOrExtraFrame || modelo === 'cabinet') {
                        profundidadCubeta = profundoLavabo - 2 * 0.025;
                    } else {
                        profundidadCubeta = dimzLavabo - 2 * 0.025 - grosorMueble;
                    }
                    break;
            }
            return {
                // Lavabo (cerámica)
                anchoLavabo,
                profundoLavabo,
                alturaLavabo,
                // Mueble (estructura / soporte / módulo)
                anchoMueble,
                profundoMueble,
                alturaMueble,
                // Cubetas
                profundidadCubeta,
            };
        },
    },
    mutations: {
        setLanguage(state, language) {
            state.language = language;
        },
        setRenderer(state, renderer) {
            state.renderer = renderer;
        },
        setAplicacion(state, aplicacion) {
            state.aplicacion = aplicacion;
        },
    },
    actions: {},
    modules: {},
});